import { ROUTE_PATTERNS } from '@/shared/config/routes';
import { StaggerItem } from '@/shared/ui/animations';

import {
  AnalysisSectionLayout,
  PROSE_CARD_STAGGER_SLOTS,
  SectionBlocks,
  type SectionBlock,
} from '../../components';
import {
  useAnalysisFromContext,
  type AnalysisSectionProps,
} from '../../utils/useAnalysisFromContext';
import { hasContent } from '../../utils/hasContent';

import { CulturalAnalysisItems, hasCulturalTruths, PeakMomentOfPower } from './components';
import { useTranslation } from 'react-i18next';

// The Peak Moment card leads the cascade from slot 0, then an empty slot lets it
// settle before Cultural Truths swipes up.
const CARD_SETTLE_GAP = 1;
const CULTURAL_TRUTHS_STAGGER = PROSE_CARD_STAGGER_SLOTS + CARD_SETTLE_GAP + 1;

export const BrandXray = ({ analysis: analysisProp, exporting }: AnalysisSectionProps = {}) => {
  const { t } = useTranslation('analysis');
  const title = t('analysisResult.brandXray.brandXRay');
  const analysis = useAnalysisFromContext(analysisProp);

  const { brandXRay } = analysis.structuredData || {};

  const blocks: SectionBlock[] = [
    {
      key: 'peak-moment',
      hasData: hasContent(brandXRay?.peakMoment),
      node: <PeakMomentOfPower peak={brandXRay?.peakMoment} staggerStart={0} />,
    },
    {
      key: 'cultural-truths',
      hasData: hasCulturalTruths(brandXRay),
      node: (
        <StaggerItem index={CULTURAL_TRUTHS_STAGGER} variant="swipeUp">
          <CulturalAnalysisItems brandXRay={brandXRay} />
        </StaggerItem>
      ),
    },
  ];

  return (
    <AnalysisSectionLayout
      analysisId={analysis.id}
      brand={analysis.brandName}
      section={ROUTE_PATTERNS.IQ_SECTION_BRAND_XRAY}
      title={title}
      subtitle={t('analysisResult.brandXray.deepCulturalAnalysis', {
        brandName: analysis.brandName,
      })}
      exporting={exporting}
    >
      <SectionBlocks category={title} blocks={blocks} />
    </AnalysisSectionLayout>
  );
};
